import { colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';

export const Container = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	height: 24px;
	top: ${props => props.top}px;
	left: ${props => props.left}px;
	width: ${props => props.width}px;
	color: ${colors.white};
	background-color: ${props =>
		props.isSummary ? '#B5E0E5' : colors.chartBrightTeal};
	z-index: 2;
	font-size: 13px;
	font-weight: ${props => (props.isSummary ? 700 : 500)};
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
	border-radius: 1px;
	&:hover {
		background-color: ${props => (props.isSummary ? '#B5E0E5' : '#007683')};
	}
	${({ isDrag, isFaded, isSummary }) => {
		if (isFaded) {
			return css`
				cursor: auto;
				opacity: 0.2;
				pointer-events: none;
			`;
		}
		if (isSummary) {
			return css`
				cursor: auto;
			`;
		}
		if (isDrag) {
			return css`
				cursor: grab;
			`;
		} else {
			return css`
				cursor: pointer;
			`;
		}
	}};
`;

export const Label = styled.div`
	position: absolute;
	left: 8px;
	top: 4px;
`;

export const LeftHandle = styled.div`
	display: none;
	position: absolute;
	height: 24px;
	right: ${props => props.right}px;
	top: 0px;
	width: ${props => props.width}px;
	border: 1px solid ${colors.chartBrightTeal};
	background-color: #b5e0e5;
	border-right: 0px;
	cursor: col-resize;
	z-index: 1;
	opacity: 0.7;
`;

export const RightHandle = styled.div`
	display: none;
	position: absolute;
	height: 24px;
	left: ${props => props.left}px;
	top: 0px;
	width: ${props => props.width}px;
	border: 1px solid ${colors.chartBrightTeal};
	background-color: #b5e0e5;
	border-left: 0px;
	cursor: col-resize;
	z-index: 1;
	opacity: 0.7;
`;

export const HandlesWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 24px;
	z-index: 1;
	&:hover ${RightHandle} {
		display: block;
	}
	&:hover ${LeftHandle} {
		display: block;
	}
`;
